import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'el',
  months: [
    'Ιανουαρίου',
    'Φεβρουαρίου',
    'Μαρτίου',
    'Απριλίου',
    'Μαΐου',
    'Ιουνίου',
    'Ιουλίου',
    'Αυγούστου',
    'Σεπτεμβρίου',
    'Οκτωβρίου',
    'Νοεμβρίου',
    'Δεκεμβρίου',
  ],
  monthsShort: ['Ιαν.', 'Φεβ.', 'Μαρ.', 'Απρ.', 'Μαΐ.', 'Ιουν.', 'Ιουλ.', 'Αυγ.', 'Σεπ.', 'Οκτ.', 'Νοεμ.', 'Δεκ.'],
  weekdays: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
  weekdaysMin: ['Κ', 'Δ', 'Τ', 'Τ', 'Π', 'Π', 'Σ'],
  weekdaysShort: ['Κυρ.', 'Δευτ.', 'Τρ.', 'Τετ.', 'Πεμ.', 'Παρ.', 'Σαβ.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([Ώρα GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([Ώρα GMT]Z)',
  },
  meridiem: { am: 'πμ', pm: 'μμ', AM: 'ΠΜ', PM: 'ΜΜ' },
  past: {
    y: { one: 'πριν από %s έτος', other: 'πριν από %s έτη' },
    M: { one: 'πριν από %s μήνα', other: 'πριν από %s μήνες' },
    w: { one: 'πριν από %s εβδ.', other: 'πριν από %s εβδ.' },
    d: { one: 'πριν από %s ημ.', other: 'πριν από %s ημ.' },
    h: { one: 'πριν από %s ώρ.', other: 'πριν από %s ώρ.' },
    m: { one: 'πριν από %s λεπ.', other: 'πριν από %s λεπ.' },
    s: { one: 'πριν από %s δευτ.', other: 'πριν από %s δευτ.' },
  },
  future: {
    y: { one: 'σε %s έτος', other: 'σε %s έτη' },
    M: { one: 'σε %s μήνα', other: 'σε %s μήνες' },
    w: { one: 'σε %s εβδ.', other: 'σε %s εβδ.' },
    d: { one: 'σε %s ημ.', other: 'σε %s ημ.' },
    h: { one: 'σε %s ώρ.', other: 'σε %s ώρ.' },
    m: { one: 'σε %s λεπ.', other: 'σε %s λεπ.' },
    s: { one: 'σε %s δευτ.', other: 'σε %s δευτ.' },
  },
  pastLong: {
    y: { one: 'πριν από %s έτος', other: 'πριν από %s έτη' },
    M: { one: 'πριν από %s μήνα', other: 'πριν από %s μήνες' },
    w: { one: 'πριν από %s εβδομάδα', other: 'πριν από %s εβδομάδες' },
    d: { one: 'πριν από %s ημέρα', other: 'πριν από %s ημέρες' },
    h: { one: 'πριν από %s ώρα', other: 'πριν από %s ώρες' },
    m: { one: 'πριν από %s λεπτό', other: 'πριν από %s λεπτά' },
    s: { one: 'πριν από %s δευτερόλεπτο', other: 'πριν από %s δευτερόλεπτα' },
  },
  futureLong: {
    y: { one: 'σε %s έτος', other: 'σε %s έτη' },
    M: { one: 'σε %s μήνα', other: 'σε %s μήνες' },
    w: { one: 'σε %s εβδομάδα', other: 'σε %s εβδομάδες' },
    d: { one: 'σε %s ημέρα', other: 'σε %s ημέρες' },
    h: { one: 'σε %s ώρα', other: 'σε %s ώρες' },
    m: { one: 'σε %s λεπτό', other: 'σε %s λεπτά' },
    s: { one: 'σε %s δευτερόλεπτο', other: 'σε %s δευτερόλεπτα' },
  },
  abbr: {
    y: { one: '%s έτ.', other: '%s έτ.' },
    M: { one: '%s μήν.', other: '%s μήν.' },
    w: { one: '%s εβδ.', other: '%s εβδ.' },
    d: { one: '%s ημ.', other: '%s ημ.' },
    h: { one: '%s ώρ.', other: '%s ώρ.' },
    m: { one: '%s λεπ.', other: '%s λεπ.' },
    s: { one: '%s δευτ.', other: '%s δευτ.' },
  },
  full: {
    y: { one: '%s έτος', other: '%s έτη' },
    M: { one: '%s μήνας', other: '%s μήνες' },
    w: { one: '%s εβδομάδα', other: '%s εβδομάδες' },
    d: { one: '%s ημέρα', other: '%s ημέρες' },
    h: { one: '%s ώρα', other: '%s ώρες' },
    m: { one: '%s λεπτό', other: '%s λεπτά' },
    s: { one: '%s δευτερόλεπτο', other: '%s δευτερόλεπτα' },
  },
  justNow: 'Μόλις τώρα',
  yesterday: 'Χθες',
  today: 'Σήμερα',
  tomorrow: 'Αύριο',
  weekStart: 1,
  timeRange: '%$1s-%$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([Ώρα GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([Ώρα GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([Ώρα GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([Ώρα GMT]Z)' },
  },
};
const localeName: LocaleName = 'el';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'πμ' : 'ΠΜ';
    } else {
      return isLowerCase ? 'μμ' : 'ΜΜ';
    }
  },
};
